module.exports = __webpack_public_path__ + "static/media/life-card.c0dc24a1.svg";